import React from 'react'
import $ from "jquery";

import { Helmet } from "react-helmet";

import {RotatingLines} from "react-loader-spinner";

import InnerHTML from "dangerously-set-html-content";
import {InView} from "react-intersection-observer";

import RelatedProduct from '../components/Product'
import ProductDetail from "../components/ProductDetail";
import { ShadowRoot } from '../components/ShadowRoot';

import CollapsibleList from '../components/CollapsibleList';

import { getImageUrl, Sizes } from '../components/blocks/editable/Img'
import ShareModal from '../components/modal/ShareModal'
import ProductSettingsModal from '../components/modal/ProductSettingsModal'

import General from '../utils/General'
import ScriptCache from '../utils/ScriptCache'
import Currency from '../utils/Currency'
import Notify from '../utils/Notify'
import Cart from '../utils/Cart'

import MockData from "../utils/MockData";
import Event from "../utils/Event";
import Backend from "../utils/Backend";
import BadgeBlock from '../components/BadgeBlock';
import DefaultData from "../utils/DefaultData";
import SafeHtml from "../components/SafeHtml";
import Navigation from '../utils/Navigation';
import PopupManagerModal, { StorefrontPopupWrapper } from '../components/modal/PopupManagerModal';
import { productSettingsIds } from '../components/constants/general';
import AuthManager from '../utils/AuthManager';
import ActionToolbar from '../components/ActionToolbar';

export function BreadcrumbNavigation(pageType, label, slug, collectionContext = null) {
  const homepageSlug = window.CURRENT_WEBSITE.homepage_slug || "";
  const homepageUrl = Navigation.getUrl(`/${homepageSlug}`);

  const homepagePath = new URL(homepageUrl, window.location.origin).pathname;
  const isHomeUrl = url => {
    try {
      const path = new URL(url, window.location.origin).pathname;
      return path === "/" || path === homepagePath;
    } catch {
      return url === "/" || url === homepagePath;
    }
  };
  let breadcrumbs = [{ label: "Home", url: homepageUrl }];
  if (pageType === "collection") {
    const slug = window.location.href;
    breadcrumbs.push({ label, url: null });
    sessionStorage.setItem("lastCollectionContext", JSON.stringify({ slug, label }));
  }
  if (pageType === "product") {
    const context = collectionContext || JSON.parse(sessionStorage.getItem("lastCollectionContext") || "null");

    if (context && context.slug && context.label) {
      breadcrumbs.push({
        label: context.label,
        url: context.slug
      });
    }
    breadcrumbs.push({ label, url: null });
  }
  return breadcrumbs;
}
export function handleBreadcrumbClick(url) {
  const homepageSlug = window.CURRENT_WEBSITE?.homepage_slug || "";
  const homepageUrl = Navigation.getUrl(`/${homepageSlug}`);
  const homepagePath = new URL(homepageUrl, window.location.origin).pathname;
  const clickedPath = new URL(url, window.location.origin).pathname;

  if (clickedPath === "/" || clickedPath === homepagePath) {
    sessionStorage.removeItem("breadcrumbTrail");
    sessionStorage.removeItem("breadcrumbTrailIndex");
    sessionStorage.removeItem("lastCollectionContext");
  }
  General.setLocationHref(url);
}

  export function generateBreadCrumbsStyles(settings = {}) {
    const borderRadius = settings.breadCrumbs_border_style ?? '0px';
    const borderColor = settings.breadCrumbs_border_color || null;
    const backgroundColor = settings.breadCrumbs_background_color ?? 'transparent';
    const linkColor = settings.breadCrumbs_link_color ?? '#4a90e2';
    const carrotColor = settings.breadCrumbs_carrot_color ?? '#666666';
    const textColor = settings.breadCrumbs_text_color ?? '#666666';
    const width = settings.breadCrumbs_width ?? null;
    const padding = settings.breadCrumbs_padding ?? '0';
    const styles = {
      borderRadius,
      borderColor,
      backgroundColor,
      linkColor,
      carrotColor,
      textColor,
      width,
      padding,
    };
    if (borderColor) {
      styles.border = `1px solid ${borderColor}`;
    }
    return styles;
  }
export default class Product extends React.Component {
  constructor(props){
    super(props)

    let productSlug = window.location.pathname.split("/").pop()
    const searchParams = new URLSearchParams(window.location.search)
    const urlVariantId = searchParams?.get("variant")

    // key is incremented as the slider js functions
    // overwrite the html so we want to refresh it
    // as React is out of sync when
    // adding/editing/deleting the images
    this.state = {
      key: 0,
      loading: true,
      quantity: 1,
      variant: [],
      customMessage: [],
      editable: props.editable,
      website: window.CURRENT_WEBSITE,
      page: props.page,
      options: [],
      productSlug,
      urlVariantId,
      campaignProductId: General.getUrlParameter("campaignProductId"),
      dropdown: General.getUrlParameter("dropdown"),
      showProductSettingsModal : false,
      openProductSettingsSection: "",
      indexLoaded: false,
      purchaseOption: "single",
      frequency: null,
      showPopupManagerModal: false,
      subscribeAndSaveSettings: window.CURRENT_WEBSITE?.extra?.subscribe_save_settings || {
        textColor: 'rgb(102, 102, 102)',
        selectedTextColor: 'rgb(102, 102, 102)',
        backgroundColor: 'rgb(252, 252, 252)',
        selectedBackgroundColor: 'rgb(252, 252, 252)',
        borderColor: 'rgb(236, 236, 236)',
        selectedBorderColor: 'rgb(236, 236, 236)',
        borderStyle: '6px',
        oneTimeIcon: '',
        subscribeIcon: '',
        activeIconTab: 'subscribe',
        discountFormat: 'price',
        useCustomIcon: false,
      }
    }

    this.quantityInput = React.createRef()

    this._updateWebsite = General.debounce(
      () => {
        Backend.updateWebsite({
          slug: this.state.website.slug,
          extra: this.state.website.extra,
          checkout_type: this.state.website.checkout_type,
        });
        this.setState({
          key: this.state.key + 1
        })
      },
      1000,
      false
    );
  }

  componentDidMount() {
    this._setup()
    if (this.state.editable) {
      Backend.getPages(window.CURRENT_WEBSITE_ID);
      Backend.getCCPages();
    }
    Event.on('WEBSITE_UPDATED', () => {
      this.setState({
        website: window.CURRENT_WEBSITE
      })
    });
    Event.on('WEBSITE_CHANGE_UPDATED', (website) => {
      this.setState({
        key: this.state.key + 1,
        website: window.CURRENT_WEBSITE,
      })
    });
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  componentWillUnmount(){
    Event.off('WEBSITE_UPDATED');
    Event.off('WEBSITE_CHANGE_UPDATED');
  }

  _setup(){
    let {
      productSlug,
      urlVariantId
    } = this.state

    this.setState({loading: true})
    Backend.getProducts(productSlug).then(products => {
      let product = products[0]
      let variant = Cart.selectDefaultVariant(product, urlVariantId)
      let variantOptions = Cart.getOptions(product)
      let customMessageOptions = Cart.getCustomMessageOptions(product)
      let purchaseOption = product.defaultProduct === 'RECURRING' ? 'recurring' : 'single'
      if(product.recurringProductId){
        Backend.getProducts(product.recurringProductId).then(subscribeAndSaveProducts => {
          let subscribeAndSaveProduct = subscribeAndSaveProducts[0]
          let subscribeAndSaveVariantOptions = Cart.getOptions(subscribeAndSaveProduct)
          this.setState({customMessageOptions, variant, variantOptions, product, purchaseOption, loading: false, subscribeAndSaveProduct, subscribeAndSaveVariantOptions}, () => this._loadJs())
        })
      }else{
        this.setState({customMessageOptions, variant, variantOptions, product, purchaseOption, loading: false}, () => this._loadJs())
      }
    }).catch(e => {
      Notify.error(e.message)
      this.setState({loading: false})
    })
  }

  _setProductInSession() {
    let {
      product
    } = this.state
    if (product?.externalProductId) {
      sessionStorage.setItem("ccProduct", JSON.stringify(product))
    }
  }

  _loadJs(){
    ScriptCache.loadDefaults()
    setTimeout(() => {
      General.updateAll()
    }, 500)
    this._mobileAddToCartStickyBtn();
    this._setCurrentItem();
    this._setProductInSession();
    this._fireApplovinViewItem();
  }

  _update(website, callback) {
    this.setState({ website }, () => {
      if (callback) {
        callback();
      }
      this._updateWebsite();
    });
  }

  _setCurrentItem() {
    let {
      product
    } = this.state
    sessionStorage.setItem("currentItem", product.campaignProductId)
  }

  _fireApplovinViewItem() {
    const hasAddOnHelpers = typeof window.getAddOnKeyValue === 'function' && typeof window.findAddOn === 'function';
    if (!hasAddOnHelpers) {
      return;
    }
    const appLovinTracking = window.getAddOnKeyValue(window.findAddOn("APPLOVIN_REQ")) === "true";
    const appLovinProductCategoryId = window.getAddOnKeyValue(window.findAddOn("APPLOVIN_CATEGORY_ID"));
    if (appLovinTracking && appLovinProductCategoryId) {
      window.ccAppLovinViewItemEvent && window.ccAppLovinViewItemEvent();
    }
  }

  _mobileAddToCartStickyBtn(){
    try {
      setTimeout(() => {
        var elementButton = $('.sticky-buttons-wrapper');
        var elementLiveChat = $('div.live-chat.main-container .live-chat-icon');
        // checks the window is less than 768px
        if (elementButton.length && $(window).width() < 768) {

          var distance = elementButton.offset().top + elementButton.outerHeight();

          $(window).scroll(function () {

            if ($(window).scrollTop() >= distance) {

              if (!elementButton.hasClass("affix")) {
                elementButton.addClass("affix");
              }

              if (elementLiveChat.length && !elementLiveChat.hasClass("up-from-btm")) {
                elementLiveChat.addClass("up-from-btm");
              }

            } else {

              if (elementButton.hasClass("affix")) {
                elementButton.removeClass("affix");
              }

              if (elementLiveChat.length && elementLiveChat.hasClass("up-from-btm")) {
                elementLiveChat.removeClass("up-from-btm");
              }

            }

        });

        }
      }, 1000)
    }
    catch (err) {
      console.error(err.message);
    }
  }

  async _onDashboardClicked() {
    this.setState({savingPage: true})
    Backend.generateThumbnail();
    await Backend.savePage();
    General.openEditFunnel();
  }

  updateSubscribeAndSaveSettings = (keyOrObject, value) => {
    this.setState(prev => {
      const { website } = this.state;
      const updatedSettings = {
        ...prev.subscribeAndSaveSettings,
        ...(typeof keyOrObject === 'object'
          ? keyOrObject
          : { [keyOrObject]: value })
      };
      if(!website.extra){
        website.extra = {subscribe_save_settings: null}
      }
      website.extra.subscribe_save_settings = updatedSettings;
      this._update(website)
      return { subscribeAndSaveSettings: updatedSettings };
    });
  };

  _renderProductSettingsButton() {
    let {
      editable,
      savingPage,
      page,
      website
    } = this.state;

    if (!editable) {
      return;
    }

    let className = "btn-fixed-left-container ignore-user-set-font";

    return (
      <div className={className}>

        <div className="d-flex">
          <button
            className="btn"
            title="Back to Funnel"
            onClick={() => this._onDashboardClicked()}
          >
            <span className="btn__text">
              {
                savingPage ?
                  <RotatingLines
                    height={24}
                    width={"24"}
                    strokeColor={"#ffffff"}
                  />
                  :
                  <span className="material-icons">exit_to_app</span>
              }
              <span className="slide-text">Back to Funnel</span>
            </span>
          </button>
        </div>

        {/* Starts : Button 01 */}
        <div className="d-flex">
          <a
            className="btn styling-button"
            title="Styling"
            onClick={() => this.setState({ showProductSettingsModal: true, openProductSettingsSection: "" })}
          >
            <span className="btn__text">
              <span class="material-icons">brush_outline</span>
              <span class="slide-text">Product Settings</span>
            </span>
          </a>
        </div>
        {/* End : Button 01 */}

        {/* Starts : Button 02 */}
        <div className="d-flex">
          <a
            className="btn styling-button"
            title="Styling"
            onClick={() => this.setState({showPopupManagerModal: true})}
          >
            <span className="btn__text">
              <span class="material-icons">wysiwyg</span>
              <span class="slide-text">Popup Manager</span>
            </span>
          </a>
          <div className="c-tool-tips six">
            {General.renderTourButtonTitle("right", "Popup Manager")}
          </div>
        </div>
        {/* End : Button 02 */}
        {/* Starts : Button 08 / 09 */}
        { (editable && AuthManager.accessToken) &&
          <>
            <ActionToolbar variant="right-bottom" page={page} website={website}/>
          </>
        }
        {/* End : Button 08 / 09 */}
      </div>
    );
  }

  _renderMeta(){
    let {
      product,
      website
    } = this.state

    if(product == null){
      return null
    }

    let favIconUrl = website.favicon ? website.favicon.original : "/favicon.ico"

    return (
      <Helmet>
        <title>{`${product.productName} | ${website.name}`}</title>
        <meta name="description" content={ product.productDescription} />
        <meta name="keywords" content={ product.productTags || website.keywords } />
        <link rel="icon" href={ favIconUrl }/>
        <meta property="og:title" content={ product.productName }/>
        <meta property="og:image" content={ product.imageUrl }/>
        <meta property="og:description" content={ product.productDescription }/>
        <meta property="og:type" content="website"/>
        <meta property="og:url" content={ window.location.href }/>
        <meta property="twitter:card" content="summary_large_image"/>
        <meta property="twitter:url" content={ window.location.href }/>
        <meta property="twitter:title" content={ product.productName }/>
        <meta property="twitter:description" content={ product.productDescription }/>
        <meta property="twitter:image" content={ product.imageUrl }/>
      </Helmet>
    )
  }

  _renderLoading(){
    return (
      <div className="main-container page product">
        {/* starts, main product section  */}
        <section className="switchable sticky-sidebars page-product pt-0 pb-4 pt-md-5">
          <div className="container">
            <div className="row justify-content-around">
              {/* starts, column right, sticky sidebar  */}
              <div className="col-md-5">
                <div className="sidebar__inner">
                  <h2 className="shimmer" style={{ height: 41}}/>
                  <div class="shimmer" style={{ width: 100, height: 26}} />
                  <div>
                    <div class="sizes my-28px">
                      <h4 class="shimmer" style={{ width: 50, height: 26}} />
                      <div class="items btn_horizontal">
                        <div class="item shimmer" style={{ width: 84, height: 39}} />
                        <div class="item shimmer" style={{ width: 84, height: 39}} />
                      </div>
                    </div>
                    <div class="my-28px">
                      <h4 class="shimmer" style={{ width: 50, height: 26}} />
                      <div class="shimmer" style={{ height: 45}} />
                    </div>
                    <div class="my-28px">
                      <h4 class="shimmer" style={{ width: 50, height: 26}} />
                      <div class="shimmer" style={{ height: 45}} />
                    </div>
                    <div class="row quan-cart my-38px mx-0">
                      <div class="col-md-4 pl-0">
                        <div class="shimmer" style={{ width: 102, height: 45}} />
                      </div>
                      <div class="col-md-8 p-md-0">
                        <div class="shimmer" style={{ height: 45}} />
                      </div>
                    </div>
                    <span class="link-share block type--fine-print text-center my-38px d-flex justify-content-center align-items-center">
                      <span class="r-box material-icons"><div class="shimmer" style={{ width: 22, height: 22}} /></span>
                      <a href="javascript:void(0)" class="text-uppercase type--underline link--primary">
                        <div class="shimmer" style={{ width: 124, height: 22}} />
                      </a>
                    </span>
                  </div>
                </div>
              </div>
              {/* end, column right, sticky sidebar  */}
              {/* starts, column left  */}
              <div className="col-md-7">
                {/* starts, slider  */}
                <div className="shimmer slider-product-main slider border--round boxed--border"/>
                {/* end, slider  */}
                <section class="switchable p-0">
                  <div class="container">
                    <div class="row justify-content-between">
                      <div class="col-md-12 col-lg-12 p-0">
                        <h2><div class="shimmer" style={{ height: 45}} /></h2>
                        <div class="lead pre"><div class="shimmer" style={{ height: 135}} /></div>
                        </div>
                      </div>
                    </div>
                  </section>
              </div>
              {/* end, column left  */}
            </div>
          </div>
        </section>
        {/* end, main product section  */}
      </div>
    )
  }

  _renderPopupManagerModal(){
    let {
      showPopupManagerModal,
      editable,
      website
    } = this.state

    return (
      <>
        {showPopupManagerModal && <PopupManagerModal
          show={showPopupManagerModal}
          onHide={() => this.setState({ showPopupManagerModal: false })}
          editable={editable}
          websitePopupCollection={website?.extra?.popup_collection || []}
          website={website}
        />}
      </>
    )
  }

  getQuickSettingsHighlightClass() {
    let {website, editable} = this.state
    const displayElementHighlight = (website?.extra?.product_page_settings?.display_quick_settings_element_highlight !== false) && editable && this.props.productPage;
    return displayElementHighlight ? 'hover-outline' : '';
  }

  _renderEditButton(id, rightDistanceInPx){
    const { editable } = this.state;
    const styleObj = {}
    if (rightDistanceInPx) {
      styleObj.right = rightDistanceInPx
    }
    return (
      editable && this.props.productPage && (
        <div
          className="edit edit-button"
          onClick={() => {
            this.setState({
              showProductSettingsModal: true,
              openProductSettingsSection: id
            })
          }}
          style={styleObj}
        >
          <i className="icon icon--xs icon-Pencil" />
        </div>
      )
    )
  }

  render(){
    let {
      key,
      editable,
      product,
      website,
      variant,
      variantOptions,
      loading,
      customMessageOptions,
      subscribeAndSaveProduct,
      subscribeAndSaveVariantOptions,
      subscribeAndSaveSettings,
      purchaseOption
    } = this.state

    if(loading){
      return (
        <>
          { this._renderLoading() }
        </>
      )
    }

    if(!product || !variantOptions){
      return null
    }

    const pageSettings = website?.extra?.product_page_settings || {};
    const evenColumnWidth = pageSettings.column_width === "even";
    const imageSliderPosition = pageSettings.slider_position || "below";

    const imageShape = pageSettings.image_shape || "rounded";
    const carouselShape = pageSettings.carousel_shape || "rounded";
    const imageNavShape = pageSettings.image_nav_shape || "square";

    const imageBorderColor = pageSettings.image_border_color || "";
    const imageSelectedBorderColor = pageSettings.image_selected_border_color || "";
    const imageNavButtonColor = pageSettings.image_nav_button_color || "";
    const autoplayCarousel = !!pageSettings.autoplay_carousel_toggle;

    const carouselStyleVars = {
      '--pd-image-border-color': imageBorderColor || undefined,
      '--pd-image-selected-border-color': imageSelectedBorderColor || undefined,
      '--pd-image-nav-button-color': imageNavButtonColor || undefined,
    };

    let layoutOrder = pageSettings?.layoutOrder;
    if (!Array.isArray(layoutOrder) || layoutOrder.length === 0) {
      layoutOrder = [...DefaultData.PRODUCT_PAGE_LAYOUT];
    }
    const breadcrumbs = BreadcrumbNavigation("product", product?.productName, website?.product_page_slug);
    const isPromoBar = website.extra?.menu_settings?.show_promo_bar
    const breadCrumbsStyles = generateBreadCrumbsStyles(this.state?.website?.extra?.product_page_settings);
    const quickSettingsHighlightClass = this.getQuickSettingsHighlightClass();

    return (
      <>
        <div className="main-container page product">
          { this._renderMeta() }
          {/* starts, main product section  */}
          <section className={`switchable sticky-sidebars page-product pt-0 pb-4 pt-md-5`}>
            <div className='container' style={{ position: 'relative' }}>
              <div className={`storefront-custom-edit-block ${quickSettingsHighlightClass}`} data-label="Breadcrumbs">
                {this._renderEditButton(productSettingsIds.breadCrumbsOptions)}
                  <div style={{...breadCrumbsStyles, marginBottom: "20px", marginTop: isPromoBar && "20px"}}>
                    <nav style={{ display: "flex", gap: "8px"}}>
                      {breadcrumbs.map((crumb, idx) => (
                        <span key={idx} style={{ display: "flex", alignItems: "center"}}>
                        {idx > 0 && <span style={{ margin: "0 6px", color: breadCrumbsStyles.carrotColor}}>{">"}</span>}
                          {idx === breadcrumbs.length - 1 || !crumb.url ? (
                            <span style={{color: breadCrumbsStyles.textColor}}>{crumb.label}</span>
                          ) : (
                            <a href={crumb.url} style={{ color: breadCrumbsStyles.linkColor }} onClick={() => handleBreadcrumbClick(crumb.url)}>{crumb.label}</a>
                          )}
                        </span>
                      ))}
                    </nav>
                </div>
              </div>
            </div>
            <div className="container" style={carouselStyleVars}>
              <ProductDetail
                key={key}
                product={product}
                variant={variant}
                purchaseOption={purchaseOption}
                variantOptions={variantOptions}
                subscribeAndSaveProduct={subscribeAndSaveProduct}
                subscribeAndSaveVariantOptions={subscribeAndSaveVariantOptions}
                subscribeAndSaveSettings={subscribeAndSaveSettings}
                customMessageOptions={customMessageOptions}
                editable={editable}
                extra={pageSettings}
                evenColumnWidth={evenColumnWidth}
                imageSliderPosition={imageSliderPosition}
                layoutOrder={layoutOrder}
                imageShape={imageShape}
                carouselShape={carouselShape}
                imageNavShape={imageNavShape}
                imageBorderColor={imageBorderColor}
                imageSelectedBorderColor={imageSelectedBorderColor}
                imageNavButtonColor={imageNavButtonColor}
                autoplayCarousel={autoplayCarousel}
                onAddToCartPressed={(
                  product,
                  variant = null,
                  customMessage =null,
                  quantity = 1,
                  frequency = null
                ) => {
                  this.props.onAddToCartPressed(product, variant, customMessage, quantity, frequency);
                }}
                updateProductSettingModalState={(showModal, sectionId, defaultIndex) => {
                  this.setState({
                    showProductSettingsModal: showModal,
                    openProductSettingsSection: sectionId,
                    defaultIndex: defaultIndex
                  })
                }}
                productPage={this.props.productPage}
              />
            </div>
          </section>
          {/* end, main product section  */}

          {/*{ this._renderRelatedProducts(product) }*/}
        </div>
        {
          pageSettings.product_page_html_lazy_load &&
          <>
            <div className={`storefront-custom-edit-block ${quickSettingsHighlightClass}`} data-label="html-code-block">
              {this._renderEditButton(productSettingsIds.htmlBlock, "10px")}
              {
                website.extra.product_page_settings.product_page_html_lazy_load &&
                <InView
                  triggerOnce={true}
                  key={key}
                >
                  {({ inView, ref, entry }) => (
                    <div ref={ref}>
                      { inView &&
                        <SafeHtml html={pageSettings.product_page_html}/>
                      }
                    </div>
                  )}
                </InView>
              }

              {
                !pageSettings.product_page_html_lazy_load &&
                <section className="block-54 text-center" key={key}>
                  <div className="container">
                    <SafeHtml html={pageSettings.product_page_html}/>
                  </div>
                </section>
              }
            </div>
          </>

        }
        {this._renderProductSettingsButton()}
        <ProductSettingsModal
          show={this.state.showProductSettingsModal}
          openProductSettingsSection={this.state.openProductSettingsSection}
          defaultIndex={this.state.defaultIndex}
          website={website}
          onCheckoutTypeUpdated={(checkoutType) => {
            website.checkout_type = checkoutType
            this._update(website)
          }}
          onUpdated={(data) => {
            if(!website.extra){
              website.extra = {product_page_settings: null}
            }
            website.extra.product_page_settings = data
            this._update(website)
          }}
          subscribeAndSaveSettings={this.state.subscribeAndSaveSettings}
          updateSubscribeAndSaveSettings={this.updateSubscribeAndSaveSettings}
          onHide={() => this.setState({showProductSettingsModal: false, openProductSettingsSection: ""})}
        />
        <div id="notification-container" class="text-center">
          <div id="notification-content"></div>
        </div>
        {this._renderPopupManagerModal()}
        {!this.state.showPopupManagerModal && <StorefrontPopupWrapper
          updateCart={(cart) => {
            this.props.onUpdatedCart && this.props.onUpdatedCart(cart);
          }}
          editableProp={editable}
          website={website}
        />
        }
      </>
    )
  }
}
